require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-5-most-effective-ecommerce-marketing-strategies.json") })
        }
      }, "path---tapd-in-5-most-effective-ecommerce-marketing-strategies");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-5-most-effective-ecommerce-marketing-strategies!./.cache/json/tapd-in-5-most-effective-ecommerce-marketing-strategies.json
// module id = 796
// module chunks = 231608221292675